import { motion, type MotionNodeAnimationOptions } from 'motion/react';
import { type Ref } from 'react';

const initialMotionOptions = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 0.2 },
};

export const MotionDiv = ({
  children,
  className,
  options = initialMotionOptions,
  ref,
}: {
  children: React.ReactNode;
  className?: string;
  options?: MotionNodeAnimationOptions;
  ref?: Ref<HTMLDivElement>;
}) => {
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={options.initial}
      animate={options.animate}
      exit={options.exit}
      transition={options.transition}
    >
      {children}
    </motion.div>
  );
};
